import React from "react";
import type { IVariant, } from "base/interfaces/product";
import styles from "./index.module.less"
import TabPartTitle from '@app/product/TabPartTitle';
import { useTrans } from 'base/utils/i18n';
import cn from 'classnames';
import { ProdTechnicalSpecs } from 'mod/product/ProdTechnicalSpecs';

interface IProps {
    shownVariant: IVariant;
}

const ProductDescription: React.FC<IProps> = (props) => {
    const { shownVariant } = props
    const { t } = useTrans();

    return (
        <div className={cn(styles.productDescriptionWrap, 'wrapper')}>
            <TabPartTitle title={t('web_product_tab_technical_specs')}/>

            <ProdTechnicalSpecs className={styles.specs} variant={shownVariant}/>
        </div>
    )
}

export default React.memo(ProductDescription);
